/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */
import { Observable } from 'rxjs/Observable';
import { Socket } from 'ngx-socket-io';
import { APP_CONFIG } from '../init.service';

let openObservables: any = {};

export function sendEmailDetailUpdate(socket: Socket, accountId, data) {
  socket.emit(APP_CONFIG.socketEvents.emailDetailChange, accountId, data);
}

export function getEmailDetailUpdate(socket: Socket) {
  if (!openObservables .inbox){
      openObservables .inbox = Observable.create((observer) => {
        socket.on(APP_CONFIG.socketEvents.emailDetailChange, (data) => {
            observer.next(data);
        });
      });
  }
  return openObservables .inbox;
}



// WEBPACK FOOTER //
// ./client/app/services/sockets/inbox.socket.ts